/* jshint node:true */
'use strict';

var browser = require('./utils/browser');
var appConfig = require('../../config');
var jQuery = require('jquery');
var mainContainerId = 'main-container';
var mainContainerSelector = '#' + mainContainerId;
var customNavSelector = '#custom-nav';
var paneMainSelector = '#pane-main';

/**
 * Clears the original ref to main-container and custom-nav
 */
function clearOriginalRefs(){
	try{
		jQuery(mainContainerSelector).remove();
		jQuery(customNavSelector).remove();
		if(history.state && history.state.customNav){
			history.state.customNav = null;
		}
	}catch(e){}
}

/**
 * Appends a new main-container to pane-main
 */
function appendNewContainer(){
	try{
		jQuery(paneMainSelector).append('<section id="' + mainContainerId + '" data-react="true"></section>');
	}catch(e){}
}

/**
 * Appends class names required on the game package page
 */
function addGamePackageClassNames(){
	try{
		if(!jQuery(paneMainSelector).attr('class')){
			jQuery(paneMainSelector).addClass('in details-header details-footer');
		}
	}catch(e){}
}

/**
 * Updates the page Object
 *  - Resets the new main-container
 *  - Updates the contentPreBehavior (required on history.change)
 * @return {[type]} [description]
 */
function updatePageObject(){
	try{
		espn_ui.Helpers.page.container = jQuery(mainContainerSelector);
		espn_ui.Helpers.page.contentPreBehavior = '<div class="main-content layout-bc"><div id="reactApp"></div></div>';
	}catch(e){}
}

module.exports = {
	postRouteRender: function(sport, page, routeChange, isGamePackage){
		
		if(isGamePackage){
			var $mainContainer = jQuery(paneMainSelector + '>' + mainContainerSelector);
			if($mainContainer.length && !$mainContainer.attr('data-react')){
				clearOriginalRefs();
				appendNewContainer();
				updatePageObject();
			}
			addGamePackageClassNames();
		}
		
		if(!routeChange){
			return;
		}
		
		updatePageObject();
	},
	preRouteRender: function(sport, page, routeChange){
		if(!routeChange){
			return;
		}
		browser.call('admgr.refreshInPageAdSlots');
		browser.call('espn_ui.Helpers.load_progress.start');
		try{
			page = (page === 'fixtures') ? 'schedule' : page;
			// Triggers page pre-render that loads necessary CSS
            jQuery(document).trigger("page.preRender",['', page, false, page, page == 'scoreboard' ? 'scoreboards-rugby' : null]);
		}catch(e){}
	}
};


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/clientStateHandlers.js
 **/